import { takeEvery, put } from "redux-saga/effects"
import { getCurrentUserPermissions } from "src/engine/repositories/permissions"
import { REQUEST_PERMISSIONS } from "../actions/types"
import {
  loadPermissionsStarted,
  loadPermissionsCompleted,
  loadPermissionsFailed,
} from "../actions/creators"

function* requestPermissions() {
  yield put(loadPermissionsStarted())

  try {
    const { data: permissions } = yield getCurrentUserPermissions({
      limit: -1,
    })

    yield put(loadPermissionsCompleted(permissions))
  } catch (error) {
    yield put(loadPermissionsFailed())
  }
}

export default function* requestPermissionsWatcher() {
  yield takeEvery(REQUEST_PERMISSIONS, requestPermissions)
}
